import React from "react";
import { Card, H1, H3, Text } from "@blueprintjs/core";
import { inject, observer } from "mobx-react";

class IPDRegister extends React.Component {
  render() {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "var(--bg-primary)",
          color: "var(--text-primary)",
          minHeight: "100vh",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <H1 style={{ color: "var(--text-primary)", margin: 0 }}>IPD Register</H1>
          <Text
            style={{
              color: "var(--text-secondary)",
              margin: "5px 0",
              fontSize: "16px",
            }}
          >
            Manage Inpatient Department registrations and admissions
          </Text>
        </div>

        <Card
          elevation={2}
          style={{
            padding: "30px",
            backgroundColor: "var(--bg-surface)",
            border: "1px solid var(--border-color)",
          }}
        >
          <H3 style={{ color: "var(--text-primary)", marginBottom: "15px" }}>IPD Register Report</H3>
          <Text style={{ color: "var(--text-secondary)", lineHeight: "1.6" }}>
            This page will provide comprehensive IPD register functionality including:
          </Text>
          <ul
            style={{
              color: "var(--text-secondary)",
              marginTop: "15px",
              paddingLeft: "20px",
              lineHeight: "1.8",
            }}
          >
            <li>Patient admission and discharge records</li>
            <li>Bed allocation and ward management</li>
            <li>IPD patient status tracking and monitoring</li>
            <li>Admission date and discharge date management</li>
            <li>Patient room and bed assignment details</li>
            <li>IPD billing and payment tracking</li>
          </ul>
          <Text
            style={{
              color: "var(--text-secondary)",
              marginTop: "20px",
              fontStyle: "italic",
            }}
          >
            This is a placeholder page. Full functionality will be implemented later.
          </Text>
        </Card>
      </div>
    );
  }
}

export default inject("authStore")(observer(IPDRegister));
